/* Copyright (c) 2017 Backpack Health LLC */

/* global window */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import CountryCodeDropdownList from 'components/features/CountryCodeDropdownList';

// import './PhoneInput.css';
import phoneFormatter from 'lib/phoneFormatter';

import TextInputWithMargin from './TextInputWithMargin';

function getPhoneFormatData(country, phone) {
  return phoneFormatter.format(country, phone);
}

class PhoneInput extends React.Component {

  constructor(props) {
    super(props);

    this.handleMobileNumberChange = this.handleMobileNumberChange.bind(this);
    this.handleCountryChange = this.handleCountryChange.bind(this);

    const phoneFormatData = getPhoneFormatData(props.country, props.phone);

    this.state = {
      formattedMobileNumber: phoneFormatData.formattedNumber,
      isInvalid: phoneFormatData.isValid,
    };
  }

  componentDidMount() {
    const phoneFormatData = getPhoneFormatData(this.props.country, this.props.phone);

    this.setState({
      formattedMobileNumber: phoneFormatData.formattedNumber,
      isInvalid: phoneFormatData.isValid,
    });
  }

  handleMobileNumberChange(event) {
    const currentFormattedNumber = event.target.value;
    const target = event.target;
    let currentCaret = event.target.selectionStart;
    if (currentFormattedNumber.length < this.state.formattedMobileNumber.length) {
      currentCaret--;
    }

    while (currentCaret > 0 && !_.isNumber(parseInt(currentFormattedNumber[currentCaret - 1], 10))) {
      currentCaret--;
    }

    const mobileNumber = currentFormattedNumber.replace(/\D/g, '');
    const phoneFormatData = getPhoneFormatData(this.props.country, mobileNumber);
    const caretPosition = currentCaret + 1;
    const isInvalid = !phoneFormatData.isValid;

    this.setState({
      formattedMobileNumber: phoneFormatData.formattedNumber,
      isInvalid,
    }, () => {
      target.selectionEnd = caretPosition;
      target.selectionStart = caretPosition;
    });

    this.props.onChangePhone(mobileNumber, isInvalid);
  }

  handleCountryChange(country) {
    const phoneFormatData = phoneFormatter.format(country, this.props.phone);
    const isInvalid = !phoneFormatData.isValid;
    this.setState({
      formattedMobileNumber: phoneFormatData.formattedNumber,
      isInvalid,
    });
    this.props.onChangeCountry(country, isInvalid);
  }

  render() {
    return (
      <TextInputWithMargin
        value={this.state.formattedMobileNumber}
        type="tel"
        label={this.props.phoneLabel}
        name="mobileNumber"
        onChange={this.handleMobileNumberChange}
        initialFocus={this.props.hasInitialFocus}
        isInvalid={this.props.isInvalid && this.props.showInvalid}
        invalidHint={this.props.errorMessage}
        isClearable={false}
        hint={this.props.phoneHint}
      >
        <CountryCodeDropdownList
          label={this.props.countryLabel}
          value={this.props.country}
          onChange={this.handleCountryChange}
          style={{ marginTop: 12 }}
        />
      </TextInputWithMargin>
    );
  }
}
PhoneInput.propTypes = {
  phone: PropTypes.string,
  country: PropTypes.string,
  onChangeCountry: PropTypes.func,
  onChangePhone: PropTypes.func,
  hasInitialFocus: PropTypes.bool,
  isClearable: PropTypes.bool,
  phoneLabel: PropTypes.any,
  countryLabel: PropTypes.any,
};

export default PhoneInput;
